/**
 * Created by fengc on 2020/04/02.
 */
import React from "react";
import PropTypes from "prop-types";
import * as Helper from "../../utils/Helper";

class Syllable extends React.Component {
	render() {
            const convertPinYin = this.props.check ? Syllable.isSyllable(this.props.data) : true;
		return (
		    !this.props.data || this.props.data === " " ? <span style={this.props.style}>&nbsp;</span> : <span style={this.props.style}>{convertPinYin ? Helper.convertToPinyin(this.props.data) : this.props.data}</span>
		);
	}
}

Syllable.propTypes = {
	style: PropTypes.object,
	data: PropTypes.string,
};

Syllable.defaultProps = {
	style: {},
	data: "",
};

Syllable.isSyllable = function(data) {
    // 暂时简单判断长度小于10的为音调
    return data && (data.length < 10);
}

export default Syllable;
